export default {
    "en": {
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "company": {
            "attributes": {
                "api_provider": "API type",
                "api_url": "API URL",
                "api_token": "API token"
            },
            "api_providers": {
                "google-shopping": "Google Shopping",
                "jetshop": "Jetshop",
                "jetshop-caparol": "Jetshop (Caparol)",
                "blocket": "Blocket"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": "The password is incorrect.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}.",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "phone": "The {attribute} field must be a valid number.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "quoteProducts": {
            "view": {
                "price_html": "<strong>{price}</strong> {currency}{vat_suffix}",
                "price_title": "Total",
                "price": "{price} {currency}{vat_suffix}",
                "vat": "VAT: {vat} {currency}",
                "discount_title": "Discount",
                "discount": "{discount} {currency}",
                "original_price": "(Original price: {price} {currency}{vat_suffix})",
                "discount_info": "{0} (Your discount - {discount} {currency}{vat_suffix} - expires today)|{1} (Your discount - {discount} {currency}{vat_suffix} - expires in {days_left} day)| (Your discount - {discount} {currency}{vat_suffix} - expires in {days_left} days)",
                "recommended_choice": "Recommended choice!",
                "no_longer_available": "This offer is no longer available, please contact the seller for more help.",
                "package_of_n_products": "Bundle with {count} products",
                "button_show_package_no_count": "Show bundle",
                "button_show_package": "Show products ({count})",
                "button_show_product": "Show product",
                "button_show_order": "Show order",
                "read_more": "Read more..",
                "view_more": "View more"
            },
            "signed": {
                "header": "{order_title} #{no}"
            }
        },
        "general": {
            "close": "Close",
            "image": "Image",
            "desc": "Description",
            "loading": "Loading",
            "title": "Title",
            "save": "Save",
            "saved": "Saved",
            "cancel": "Cancel",
            "email": "Email",
            "placeholderOptional": "(Optional)",
            "activateModule": "Activate module",
            "remove": "Remove",
            "errors": {
                "unauthenticated": "You need to sign in to do that.",
                "forbidden": "You don't have permission to do that.",
                "not_found": "That resource could not be found.",
                "session_expired": "Your session has expired — refreshing…",
                "too_many_requests": "Too many requests. Please slow down.",
                "server": "Something went wrong. Please try again.",
                "unavailable": "Service unavailable. Please try again shortly.",
                "network": "Network error. Check your connection.",
                "fallback": "Something went wrong. Please try again."
            }
        },
        "sign": {
            "sign_order": "Sign",
            "clear_on_screen_signature_pad": "Start over",
            "saving_on_screen_signature": "Saving your signature",
            "name_label": "Your Name",
            "on_screen_signature_pad_label": "Sign here",
            "email_format_hint": "Enter a valid email address, for example name@example.com",
            "simple": {
                "consent": "Click to confirm that you want to sign",
                "consent_required": "You must confirm before signing."
            }
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "currencies": {
            "sek_kr": "kr",
            "sek_ore": "öre"
        },
        "products": {
            "attributes": {
                "product_id": "Product ID",
                "sku": "SKU",
                "url": "Link",
                "name": "Name",
                "description_title": "Description, heading",
                "description": "Description, text",
                "image": "Image",
                "image_url": "Image URL",
                "categories": "Categories",
                "category": "Category",
                "allows_user_assigned_price": "Customer sets price",
                "allows_seller_assigned_price": "Seller sets price",
                "solo_product": "Product cannot be combined with others.",
                "price_including_vat": "Price (incl. VAT)",
                "original_price_including_vat": "Original price (incl. VAT)",
                "minimum_price_including_vat": "Minimum Price (incl. VAT)",
                "currency": "Currency",
                "price_unit": "Unit",
                "input_amount": "Seller can specify quantity",
                "input_prompt": "Prompt when creating quote?",
                "color": "Color",
                "pattern": "Pattern",
                "material": "Material",
                "age_group": "Age group",
                "gender": "Gender",
                "size": "Size",
                "alternative_product": "Alternative product",
                "in_stock": "In stock",
                "deleted": "Hidden",
                "manuellt_skapad": "Manually created",
                "is_recurring": "Is recurring",
                "source": "Source",
                "stock": "Stock",
                "recurring": "Recurring",
                "visibility": "Visibility",
                "updated_at": "Updated"
            },
            "genders": {
                "male": "Male",
                "female": "Female",
                "unisex": "Unisex"
            },
            "age_groups": {
                "newborn": "Newborn",
                "infant": "Infant",
                "toddler": "Toddler",
                "kids": "Kids",
                "adult": "Adult"
            },
            "units": {
                "st": "{currency}/st",
                "kWh": "{currency}/kWh",
                "month": "{currency}/month",
                "month-billed-yearly": "{currency}/month (billed yearly)",
                "year": "{currency}/year"
            },
            "unit_with_price": {
                "st": "{price} {currency}/st{vat_suffix}",
                "kWh": "{price} {currency}/kWh{vat_suffix}",
                "month": "{price} {currency}/month{vat_suffix}",
                "month-billed-yearly": "{price} {currency}/month{vat_suffix} (billed yearly)",
                "year": "{price} {currency}/year{vat_suffix}"
            },
            "unit_with_amount_and_price": {
                "st": "{amount} pcs á {price} {currency}{vat_suffix}",
                "kWh": "{amount} pcs á {price} {currency}/kWh{vat_suffix}",
                "month": "{amount} pcs á {price} {currency}/month{vat_suffix}",
                "month-billed-yearly": "{amount} pcs á {price} {currency}/month{vat_suffix} (billed yearly)",
                "year": "{amount} pcs á {price} {currency}/year{vat_suffix}"
            },
            "editor": {
                "header": "Products",
                "header_manually_created": "Products (Manual)",
                "header_integration_created": "Products (API)",
                "header_categories": "Categories",
                "button_create": "Create new product",
                "button_edit": "Edit",
                "button_clone": "Clone",
                "button_save_existing": "Save",
                "button_save_new": "Create",
                "button_view": "View",
                "button_add_category": "Add category",
                "save_error": "An error occurred, please try again.",
                "save_success": "Your changes have been saved!",
                "required": "Required fields are marked with *",
                "optional": "Optional",
                "select_true": "Yes",
                "select_false": "No",
                "sku_in_use_error": "SKU is already in use by another product.",
                "pick_alternative_product": "Pick alternative product",
                "input_amount_disabled_hint": "Input amount is disabled when price is assigned dynamically.",
                "alternative_product_disabled_hint": "Alternative product is unavailable when price is assigned dynamically.",
                "alternative_product_search_min_chars": "Type at least 2 characters to search products.",
                "alternative_product_search_no_results": "No matching products found.",
                "search_placeholder": "Search products...",
                "button_archive": "Archive",
                "archive_confirm": "Are you sure you want to archive this product? It will be hidden from the catalog but not deleted.",
                "button_purge": "Delete permanently",
                "purge_requires_archive": "Archive this product first to enable permanent deletion.",
                "purge_admin_only": "Only company admins can permanently delete a product.",
                "button_restore": "Restore",
                "restore_confirm": "Restore this product to the catalog?",
                "actions": "Actions",
                "no_products": "No products found.",
                "profile_label": "Profile:"
            },
            "purge_modal": {
                "title": "Permanently delete this product?",
                "warning": "This is permanent and can’t be undone. The product is removed from the catalog and from unsigned quotes; signed quotes keep their saved copy.",
                "not_used": "This product isn’t used in any quote, bundle, or catalog.",
                "stat_signed": "Signed quotes (preserved)",
                "stat_unsigned": "Unsigned quotes (product will be removed)",
                "stat_emptied": "Of those, left with no products at all",
                "stat_bundles": "Bundles this product belongs to",
                "stat_alternative_of": "Products using this as their alternative",
                "stat_catalogs": "Quote-profile catalogs",
                "confirm_label": "Type \"delete\" to confirm",
                "cancel": "Cancel",
                "submit": "Delete permanently"
            },
            "reload": {
                "button": "Reload from API",
                "success": "Product reload has been started!",
                "failure": "Product reload could not be completed, please try again later!",
                "in_progress": "Product reload has been started. This may take a few minutes."
            },
            "setup": {
                "button": "Set up profile products",
                "success": "Profile product setup started",
                "in_progress": "Setting up profile products"
            },
            "saved": "Product saved successfully!",
            "filters": {
                "all_kinds": "All kinds",
                "manual": "Manual",
                "imported": "Imported",
                "active": "Active",
                "deleted": "Deleted / Hidden",
                "all_visibility": "All visibility",
                "all_stock": "All stock",
                "in_stock": "In stock",
                "out_of_stock": "Out of stock",
                "all_recurring": "All recurring",
                "recurring": "Recurring",
                "non_recurring": "Non-recurring"
            },
            "source": {
                "manual": "Manual",
                "imported": "Imported"
            },
            "stock": {
                "in_stock": "In stock",
                "out_of_stock": "Out of stock"
            },
            "recurring": {
                "yes": "Yes",
                "no": "No"
            },
            "visibility": {
                "visible": "Visible",
                "hidden": "Hidden"
            },
            "status": {
                "hidden": "Hidden"
            },
            "loading": "Loading",
            "bulk": {
                "selected_count": "selected",
                "clear_selection": "Clear selection",
                "delete": "Archive selected",
                "delete_confirm": "Are you sure you want to archive the selected products?",
                "export": "Export",
                "export_title": "Export selected products",
                "export_description": "Choose which columns to include in the CSV export.",
                "export_submit": "Download CSV"
            },
            "drawer": {
                "create_title": "Create product",
                "edit_title": "Edit product",
                "imported_title": "Product details",
                "optional_title": "More settings",
                "optional_description": "Expand to edit attributes, categories, alternatives, and status.",
                "optional_show": "Show more",
                "optional_hide": "Show less"
            },
            "sections": {
                "general": "General",
                "media": "Media",
                "pricing": "Pricing",
                "attributes": "Attributes",
                "categories": "Categories",
                "alternative": "Alternative product",
                "status": "Status"
            },
            "categories": {
                "placeholder": "Category",
                "empty": "No categories added."
            },
            "alternative": {
                "placeholder": "Product ID"
            },
            "configure_api_url": {
                "button_open": "Configure API URL",
                "button_close": "Close settings",
                "button_submit": "Save",
                "title": "Configure API URL",
                "description": "Control the source provider and credentials for product sync.",
                "token_placeholder": "Paste API token or secret here",
                "success": "Your change has been saved!",
                "failure": "Your change could not be saved, please try again later!",
                "validation": {
                    "provider_required_with": "Choose a provider when URL or token are filled in.",
                    "url_required_with": "Enter a URL when provider or token are filled in."
                }
            },
            "bundles": {
                "attributes": {
                    "name": "Name",
                    "product_amount": "Amount"
                },
                "editor": {
                    "header": "Product bundles",
                    "button_create": "Create new",
                    "button_edit": "Edit",
                    "button_save_existing": "Save",
                    "button_save_new": "Create",
                    "pick_product": "Add product",
                    "save_error": "An error occurred, please try again.",
                    "save_success": "Your changes have been saved!"
                }
            }
        },
        "quoteProfile": {
            "bankid_auto_start_enabled": "Start BankID automatically in the checkout (otherwise the customer starts signing themselves)",
            "signature_types": {
                "bankid": "Swedish BankID (old)",
                "bankidv2": "Swedish BankID (v3)",
                "on-screen": "E-Sign on Screen",
                "simple": "E-sign (button)",
                "none": "No signature"
            },
            "checkout_flows": {
                "automatic": "Automatic (from the offer type)",
                "purchase": "Purchase",
                "donation": "Donation",
                "document_signing": "Document signing"
            }
        },
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have emailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that email address."
        }
    },
    "sv": {
        "quote": {
            "default_email_subject": "Din offert från <company_legal>",
            "signature_revoked_sms": "Hej <customer>, jag har nu återkallat din signatur.",
            "signature_revoked_email": "Hej <customer>, jag har nu återkallat din signatur.",
            "signature_revoked_chat": "Jag har nu återkallat din signatur.",
            "signature_revoked_subject": "Din signatur har återkallats"
        },
        "imageCarousel": {
            "addImage": "Lägg till bild",
            "replaceImage": "Byt bild",
            "deleteImage": "Radera bild"
        },
        "form": {
            "clone_name_prefix": "Kopia av",
            "clone": "Kopiera",
            "delete": "Radera",
            "publish": "Publicera",
            "draft": "Förslag",
            "fields": {
                "name": "Namn",
                "phoneNumber": "Mobilnummer",
                "email": "E-post",
                "company": "Företag",
                "notes": "Anteckningar"
            }
        },
        "company": {
            "attributes": {
                "api_provider": "API-typ",
                "api_url": "API-url",
                "api_token": "API-token"
            },
            "api_providers": {
                "google-shopping": "Google Shopping",
                "jetshop": "Jetshop",
                "jetshop-caparol": "Jetshop (Caparol)",
                "blocket": "Blocket"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": "The password is incorrect.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}.",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "phone": "Telefonfältet måste vara ett giltigt nummer",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "quoteProducts": {
            "view": {
                "price_html": "<strong>{price}</strong> {currency}{vat_suffix}",
                "price_title": "Totalt",
                "price": "{price} {currency}{vat_suffix}",
                "vat": "Moms: {vat} {currency}",
                "discount_title": "Rabatt",
                "discount": "{discount} {currency}",
                "original_price_title": "Ordinarie pris",
                "original_price": "(Ordinarie pris: {price} {currency}{vat_suffix})",
                "discount_info": "{0} (Er rabatt på {discount} {currency}{vat_suffix} löper idag)|{1} (Er rabatt på {discount} {currency}{vat_suffix} löper ut om {days_left} dag)| (Er rabatt på {discount} {currency}{vat_suffix} löper ut om {days_left} dagar)",
                "recommended_choice": "Rekommenderat val!",
                "no_longer_available": "Detta erbjudande är ej längre tillgängligt, vad god kontakta säljare för mer hjälp.",
                "package_of_n_products": "Paket om {count} produkter",
                "button_show_package_no_count": "Visa paket",
                "button_show_package": "Visa produkter ({count})",
                "button_show_product": "Visa produkt",
                "button_show_order": "Visa order",
                "read_more": "Läs mer..",
                "view_more": "Visa mer"
            },
            "signed": {
                "header": "{order_title} #{no}"
            },
            "vat_suffix": {
                "including": "",
                "excluding": " ex. moms"
            }
        },
        "pdfView": {
            "shownNow": "Visas nu",
            "moreDocuments": "Fler dokument",
            "page": "Sida",
            "strange": "Not loading?",
            "openNewTab": "Open in new tab",
            "offer_expired": "Ditt erbjudande har gått ut.",
            "offer_expired_contact": "Kontakta mig om du har frågor eller vill ha ett förnyat erbjudande."
        },
        "general": {
            "close": "Stäng",
            "image": "Bild",
            "desc": "Beskrivning",
            "loading": "Laddar",
            "title": "Rubrik",
            "save": "Spara",
            "saved": "Sparad",
            "cancel": "Avbryt",
            "email": "E-post",
            "placeholderOptional": "(Behöver ej anges)",
            "activateModule": "Aktivera modul",
            "remove": "Ta bort",
            "errors": {
                "unauthenticated": "Du måste logga in för att göra det.",
                "forbidden": "Du har inte behörighet att göra det.",
                "not_found": "Resursen kunde inte hittas.",
                "session_expired": "Din session har gått ut — laddar om…",
                "too_many_requests": "För många förfrågningar. Försök igen om en stund.",
                "server": "Något gick fel. Försök igen.",
                "unavailable": "Tjänsten är inte tillgänglig just nu. Försök igen om en stund.",
                "network": "Nätverksfel. Kontrollera din anslutning.",
                "fallback": "Något gick fel. Försök igen."
            }
        },
        "sign": {
            "show_signed": "Visa signering",
            "sign_document": "Signera dokument",
            "show_document": "Visa dokument",
            "show_order": "Visa order",
            "sign_quote": "Signera offert",
            "move_forward": "Gå vidare",
            "modal_explainer": "FÖR ATT LÄGGA BESTÄLLNING:\n1. Markera rätt alternativ nedan (blå ram)\n2. Fyll i personnummer\n3. Klicka på \"Signera\" för att signera med BankID.\n\n(Vill du istället läsa er offert. Klicka på visa dokument.)",
            "pno": "Personnummer",
            "pno_format": "12 siffror utan bindestreck",
            "sign_order": "Signera",
            "more_documents": "Fler dokument",
            "more_options": "Se alternativ",
            "move_forward_max_length": "Max 30 tecken",
            "add_signature_max_length": "Max 30 tecken",
            "clear_on_screen_signature_pad": "Börja om",
            "saving_on_screen_signature": "Sparar din signatur",
            "name_label": "Ditt namn",
            "on_screen_signature_pad_label": "Signera här",
            "email_format_hint": "Ange en giltig e-postadress, till exempel namn@exempel.se",
            "external": {
                "name_label": "Signerat av"
            },
            "simple": {
                "consent": "Markera för att bekräfta att du vill signera",
                "consent_required": "Du måste bekräfta innan du signerar."
            }
        },
        "quotePayment": {
            "product": {
                "name_label": "Bekräfta ditt namn",
                "go_to_payment_button": "Gå vidare till betalning"
            }
        },
        "currencies": {
            "sek_kr": "kr",
            "sek_ore": "öre"
        },
        "products": {
            "attributes": {
                "product_id": "Produkt-ID",
                "sku": "Artikelnummer",
                "url": "Länk",
                "name": "Namn",
                "description_title": "Beskrivning, rubrik",
                "description": "Beskrivning, text",
                "image": "Bild",
                "image_url": "Bild-URL",
                "categories": "Kategorier",
                "category": "Kategori",
                "allows_user_assigned_price": "Kund anger själv pris på produkten",
                "allows_seller_assigned_price": "Säljaren anger själv pris på produkten",
                "solo_product": "Produkt kan ej kombineras med andra.",
                "price_including_vat": "Pris (inkl. ev. moms)",
                "original_price_including_vat": "Ordinarie pris (inkl. ev. moms)",
                "minimum_price_including_vat": "Lägsta Pris (inkl. ev. moms)",
                "currency": "Valuta",
                "price_unit": "Enhet",
                "input_amount": "Säljare kan ange antal vid offertskapande",
                "input_prompt": "Fråga vid offertskapande?",
                "color": "Färg",
                "pattern": "Mönster",
                "material": "Material",
                "age_group": "Åldersgrupp",
                "gender": "Användare",
                "size": "Storlek",
                "alternative_product": "Alternativ produkt",
                "in_stock": "I Lager",
                "deleted": "Dold",
                "manuellt_skapad": "Manuellt skapad",
                "is_recurring": "Är återkommande",
                "source": "Källa",
                "stock": "Lager",
                "recurring": "Återk.",
                "visibility": "Synlighet",
                "updated_at": "Uppdaterad"
            },
            "genders": {
                "male": "Herr",
                "female": "Dam",
                "unisex": "Unisex"
            },
            "age_groups": {
                "newborn": "Nyfödd",
                "infant": "Spädbarn",
                "toddler": "Småbarn",
                "kids": "Barn",
                "adult": "Vuxen"
            },
            "units": {
                "st": "{currency}/st",
                "kWh": "{currency}/kWh",
                "month": "{currency}/mån",
                "month-billed-yearly": "{currency}/mån (faktureras årsvis)",
                "year": "{currency}/år"
            },
            "unit_with_price": {
                "st": "{price} {currency}/st{vat_suffix}",
                "kWh": "{price} {currency}/kWh{vat_suffix}",
                "month": "{price} {currency}/mån{vat_suffix}",
                "month-billed-yearly": "{price} {currency}/mån{vat_suffix} (faktureras årsvis)",
                "year": "{price} {currency}/år{vat_suffix}"
            },
            "unit_with_amount_and_price": {
                "st": "{amount} st á {price} {currency}{vat_suffix}",
                "kWh": "{amount} st á {price} {currency}/kWh{vat_suffix}",
                "month": "{amount} st á {price} {currency}/mån{vat_suffix}",
                "month-billed-yearly": "{amount} st á {price} {currency}/mån{vat_suffix} (faktureras årsvis)",
                "year": "{amount} st á {price} {currency}/år{vat_suffix}"
            },
            "editor": {
                "header": "Produkter",
                "header_manually_created": "Produkter (Manuella)",
                "header_integration_created": "Produkter (API)",
                "header_categories": "Kategorier",
                "button_create": "Skapa ny produkt",
                "button_edit": "Redigera",
                "button_clone": "Kopiera",
                "button_save_existing": "Spara",
                "button_save_new": "Skapa",
                "button_view": "Visa",
                "button_add_category": "Lägg till kategori",
                "save_error": "Fel uppstod, var god försök igen.",
                "save_success": "Dina ändringar är sparade!",
                "required": "Obligatoriska fält markeras med *",
                "optional": "Valfritt",
                "select_true": "ja",
                "select_false": "nej",
                "sku_in_use_error": "Artikelnummer används redan till en annan produkt.",
                "pick_alternative_product": "Välj alternativ produkt",
                "input_amount_disabled_hint": "Antal kan inte anges när priset sätts dynamiskt.",
                "alternative_product_disabled_hint": "Alternativ produkt kan inte väljas när priset sätts dynamiskt.",
                "alternative_product_search_min_chars": "Skriv minst 2 tecken för att söka produkter.",
                "alternative_product_search_no_results": "Inga matchande produkter hittades.",
                "search_placeholder": "Sök produkter...",
                "button_archive": "Arkivera",
                "archive_confirm": "Är du säker på att du vill arkivera denna produkt? Den döljs från katalogen men tas inte bort.",
                "button_purge": "Ta bort permanent",
                "purge_requires_archive": "Arkivera produkten först för att kunna ta bort den permanent.",
                "purge_admin_only": "Endast företagsadministratörer kan ta bort en produkt permanent.",
                "button_restore": "Återställ",
                "restore_confirm": "Återställ denna produkt till katalogen?",
                "actions": "Åtgärder",
                "no_products": "Inga produkter hittades.",
                "profile_label": "Profil:"
            },
            "purge_modal": {
                "title": "Ta bort denna produkt permanent?",
                "warning": "Detta är permanent och kan inte ångras. Produkten tas bort från katalogen och från osignerade offerter; signerade offerter behåller sin sparade kopia.",
                "not_used": "Denna produkt används inte i någon offert, paket eller katalog.",
                "stat_signed": "Signerade offerter (bevaras)",
                "stat_unsigned": "Osignerade offerter (produkten tas bort)",
                "stat_emptied": "Av dessa, blir helt tomma",
                "stat_bundles": "Paket denna produkt ingår i",
                "stat_alternative_of": "Produkter som har denna som sitt alternativ",
                "stat_catalogs": "Offertprofil-kataloger",
                "confirm_label": "Skriv \"delete\" för att bekräfta",
                "cancel": "Avbryt",
                "submit": "Ta bort permanent"
            },
            "reload": {
                "button": "Ladda om från API",
                "success": "Omladdning av produkter har påbörjats!",
                "failure": "Omladdning av produkter kunde ej genomföras, försök igen senare!",
                "in_progress": "Omladdning av produkter har påbörjats. Detta kan ta några minuter."
            },
            "setup": {
                "button": "Konfigurera profilprodukter",
                "success": "Konfigurering av profilprodukter har startat",
                "in_progress": "Konfigurerar profilprodukter"
            },
            "saved": "Produkten har sparats!",
            "filters": {
                "all_kinds": "Alla typer",
                "manual": "Manuella",
                "imported": "Importerade",
                "active": "Aktiva",
                "deleted": "Dolda",
                "all_visibility": "All synlighet",
                "all_stock": "Allt lager",
                "in_stock": "I lager",
                "out_of_stock": "Ej i lager",
                "all_recurring": "Alla återkommande",
                "recurring": "Återkommande",
                "non_recurring": "Ej återkommande"
            },
            "source": {
                "manual": "Manuell",
                "imported": "Importerad"
            },
            "stock": {
                "in_stock": "I lager",
                "out_of_stock": "Ej i lager"
            },
            "recurring": {
                "yes": "Ja",
                "no": "Nej"
            },
            "visibility": {
                "visible": "Synlig",
                "hidden": "Dold"
            },
            "status": {
                "hidden": "Dold"
            },
            "loading": "Laddar",
            "bulk": {
                "selected_count": "valda",
                "clear_selection": "Avmarkera",
                "delete": "Arkivera valda",
                "delete_confirm": "Är du säker på att du vill arkivera de valda produkterna?",
                "export": "Exportera",
                "export_title": "Exportera valda produkter",
                "export_description": "Välj vilka kolumner som ska ingå i CSV-exporten.",
                "export_submit": "Ladda ner CSV"
            },
            "drawer": {
                "create_title": "Skapa produkt",
                "edit_title": "Redigera produkt",
                "imported_title": "Produktdetaljer",
                "optional_title": "Fler inställningar",
                "optional_description": "Visa attribut, kategorier, alternativ och status vid behov.",
                "optional_show": "Visa fler",
                "optional_hide": "Visa färre"
            },
            "sections": {
                "general": "Allmänt",
                "media": "Media",
                "pricing": "Prissättning",
                "attributes": "Attribut",
                "categories": "Kategorier",
                "alternative": "Alternativ produkt",
                "status": "Status"
            },
            "categories": {
                "placeholder": "Kategori",
                "empty": "Inga kategorier tillagda."
            },
            "alternative": {
                "placeholder": "Produkt-ID"
            },
            "configure_api_url": {
                "button_open": "Konfigurera API-url",
                "button_close": "Stäng inställningar",
                "button_submit": "Spara",
                "title": "Konfigurera API-url",
                "description": "Styr källa, provider och inloggningsuppgifter för produktsynk.",
                "token_placeholder": "Klistra in API-token eller hemlig nyckel här",
                "success": "Din ändring har sparats!",
                "failure": "Din ändring kunde inte sparas, försök igen senare!",
                "validation": {
                    "provider_required_with": "Välj en provider när URL eller token är ifyllda.",
                    "url_required_with": "Ange en URL när provider eller token är ifyllda."
                }
            },
            "bundles": {
                "attributes": {
                    "name": "Namn",
                    "product_amount": "Antal"
                },
                "editor": {
                    "header": "Produkt-paket",
                    "button_create": "Skapa nytt",
                    "button_edit": "Redigera",
                    "button_save_existing": "Spara",
                    "button_save_new": "Skapa",
                    "pick_product": "Lägg till produkt",
                    "save_error": "Fel uppstod, var god försök igen.",
                    "save_success": "Dina ändringar är sparade!"
                }
            }
        },
        "user": {
            "signature_image_width": {
                "small": "Liten (200px)",
                "medium": "Standard (350px)",
                "large": "Stor (500px)"
            }
        },
        "recurringMembers": {
            "metrics": {
                "new_members": "nya denna månad",
                "new_members_title": "{count} nya återkommande medlemmar denna månad",
                "realized_title": "Debiterat per månad under de senaste 12 avslutade månaderna",
                "realized_aria": "Debiterad återkommande intäkt de senaste 12 avslutade månaderna",
                "realized_footer": "debiterat {amount} i {month}"
            },
            "history": {
                "paid": "Betald",
                "failed": "Misslyckad debitering",
                "retrying": "Misslyckad debitering · försöker igen",
                "exhausted": "Misslyckad debitering · försök uttömda",
                "created": "Debitering skapad",
                "consent": "Samtycke tecknat",
                "attempt": "Försök {number}",
                "last_attempt": "sista försöket",
                "scheduled": "planerad",
                "reason_unknown": "orsak saknas"
            },
            "export": {
                "button": "Exportera CSV",
                "title": "Exportera återkommande medlemmar",
                "description": "Alla medlemmar som matchar nuvarande sökning, status och leverantör exporteras, även de som ligger på andra sidor.",
                "columns": "Välj kolumner",
                "submit": "Ladda ner CSV",
                "preparing": "Förbereder…"
            },
            "columns": {
                "quote_id": "Offert-ID",
                "name": "Namn",
                "phone": "Mobilnummer",
                "email": "E-post",
                "pno": "Personnummer",
                "product": "Produkt",
                "provider": "Betalleverantör",
                "amount": "Avtalat belopp",
                "interval": "Intervall",
                "next": "Nästa debitering",
                "last_outcome": "Senaste utfall",
                "last": "Senaste datum",
                "lifetime": "Livstidsvärde",
                "charges": "Antal debiteringar",
                "status": "Status",
                "converted": "Medlem sedan"
            },
            "confirm": {
                "charge_title": "Debitera nu",
                "charge": "Debitera {amount} från {name} nu? Pengarna dras direkt och det går inte att ångra.",
                "charge_submit": "Ja, debitera",
                "pause_title": "Pausa debiteringar",
                "pause": "Pausa kommande debiteringar för {name}? Inga nya debiteringar skickas förrän du återupptar.",
                "pause_submit": "Ja, pausa",
                "cancel_title": "Avsluta medlemskap",
                "cancel": "Avslut är permanent och samtycket återkallas hos {provider}. {name} måste teckna ett nytt samtycke för att starta om.",
                "cancel_submit": "Ja, avsluta",
                "abort": "Avbryt",
                "working": "Utför…"
            },
            "interval": {
                "monthly": "Månatlig",
                "quarterly": "Kvartalsvis",
                "yearly": "Årlig"
            },
            "status": {
                "active": "Aktiv",
                "retry": "Försöker igen",
                "review": "Granskning krävs",
                "paused": "Pausad",
                "revoked": "Återkallad",
                "inactive": "Inaktiv · betalning"
            },
            "outcome": {
                "paid": "Betald",
                "failed": "Misslyckad",
                "consent": "Samtycke"
            }
        },
        "contact": {
            "callBack": "Uppringning",
            "email": "Maila",
            "call": "Ring",
            "cta": "Hej {customerName}, jag hjälper gärna till om ni har frågor. Välj det alternativ nedan som passar er bäst."
        },
        "readmore": {
            "moduleName": "Modul: Läs mer",
            "page": "Läs mer-sida",
            "addPage": "Lägg till ny \"Läs mer\"-sida",
            "replaceImage": "Ersätt bild",
            "image": "Bild",
            "title": "Title",
            "body": "Text",
            "youtube_url": "Youtube-länk",
            "category": "Kategori",
            "cta_title": "Knapp-titel",
            "cta_url": "Knapp-länk",
            "cta_placeholderOptional": "(Behöver ej anges om knapp inte skall visas)",
            "isFullwidth": "Visa i fullbredd på kundsidan",
            "pageContentBlock": "Innehållsblock",
            "pageContentBlocks": "Sidans innehåll",
            "addPageContentBlock": "Lägg till nytt innehållsblock",
            "noTemplateSelected": "Ingen mall vald",
            "templatePrefix": "Mall: "
        },
        "view": {
            "upload_image": "Ladda upp bild",
            "unsubscribe": "Avregistrera",
            "decline_quote": "Tacka nej till offert",
            "contact": "Kontakta"
        },
        "quoteProfile": {
            "clone_name_prefix": "Kopia av",
            "clone": "Kopiera",
            "setAsDefault": "Standard",
            "delete": "Radera",
            "change": "Ändra",
            "deleteNotAllowed": "Profilen kan ej raderas då det finns data i systemet kopplat till den.",
            "defaultBadge": "Standard",
            "visibleToSellers": "Synlig för säljare",
            "defaultProfile": "Standardprofil",
            "changeType": "Ändra typ…",
            "deleteProfile": "Radera profil…",
            "moreActions": "Fler åtgärder",
            "hiddenSuffix": "(dold)",
            "hideNotAllowed": "Standardprofilen kan inte döljas. Välj en annan profil som standard först.",
            "quote_created_email": "Nytt erbjudande",
            "brand_awareness_created_email": "Nytt visitkort",
            "quote_update_emails": "Uppdateringar om erbjudandet (ändringar, signaturbekräftelse, förfrågan om projektbekräftelse etc)",
            "quote_created_email_default": "Din offert från <company_legal>",
            "quote_message_automation_emails": "Automatiska utskick",
            "default_send_type_title": "Utskickstyp",
            "default_send_type_description": "Välj vilka kanaler som skall vara förvalda",
            "allows_external_signature": "Tillåt extern signatur (rapporterad av säljare)",
            "bankid_auto_start_enabled": "Starta BankID automatiskt i checkouten (annars startar kunden signeringen själv)",
            "triggers_checkout_webhooks_on_external_signatures": "Låt externa signaturer utlösa konverteringswebhooks (Google Ads, Meta, generisk)",
            "recurring_seller_notifications_enabled": "Notifiera säljaren vid misslyckad återkommande betalning och inaktiverat medlemskap",
            "email_sender_format": "Avsändare",
            "email": {
                "header": "E-post",
                "subject": "Ämnesrad",
                "body": "Innehåll"
            },
            "signed_quotes_view": {
                "header": "Verifikat"
            },
            "signature_types": {
                "bankid": "Svenskt BankID (gammal)",
                "bankidv2": "Svenskt BankID (v3)",
                "on-screen": "E-Signatur på skärmen",
                "simple": "E-signatur (knapptryck)",
                "none": "Ingen signatur"
            },
            "checkout_flows": {
                "automatic": "Automatiskt (utifrån erbjudandetypen)",
                "purchase": "Köp",
                "donation": "Gåva",
                "document_signing": "Dokumentsignering"
            },
            "vibe": {
                "header": "VIBBA",
                "description": "Standardmeddelande för VIBBA-utskick",
                "message": "Meddelande"
            },
            "seller_activity": {
                "header": "Säljaraktivitet"
            },
            "settings": {
                "terms": "Villkor"
            },
            "terms": {
                "enabled": "Aktivera modul",
                "header": "Rubrik",
                "body": "Text",
                "link": "Länk",
                "link_url": "URL",
                "link_title": "Namn",
                "button_remove_link": "Ta bort",
                "button_add_link": "Lägg till länk"
            },
            "custom-fields": {
                "header": "Mer information",
                "subheader": "Fält {n}:",
                "type": "Typ",
                "label": "Label",
                "types": {
                    "text": "Text",
                    "date": "Datum",
                    "number": "Nummer",
                    "email": "E-mail",
                    "tel": "Telefonnummer",
                    "textarea": "Längre text",
                    "swedish-id-number": "Svenskt ID-nummer",
                    "swedish-bank-account-number": "Svenskt clearingnummer",
                    "swedish-bank-clearing-number": "Svenskt kontonummer",
                    "country": "Land"
                }
            },
            "field-types": {
                "fixed": "Fixed",
                "custom": "Custom"
            },
            "custom-fields-versions": {
                "v1": "Ver 1",
                "v2": "Ver 2",
                "cannot-downgrade": "En kundprofil på Ver 2 kan inte flyttas tillbaka till Ver 1.",
                "super-admin-only": "Endast SalesByte kan byta version på en kundprofil."
            }
        },
        "surveys": {
            "editor": {
                "button_cancel": "Avbryt",
                "button_create": "Skapa ny",
                "button_edit": "Ändra",
                "button_preview": "Se",
                "button_question_add": "Lägg till fråga",
                "button_question_move_down": "↓",
                "button_question_move_up": "↑",
                "button_question_option_add": "Lägg till",
                "button_save_existing": "Spara",
                "button_save_new": "Skapa",
                "header": "Enkäter",
                "none_exists": "Du har inga enkäter än.",
                "question_title": "Fråga {num}",
                "save_error": "Kunde inte spara enkäten.",
                "save_success": "Enkäten sparades.",
                "pick_product": "Välj produkt",
                "pick_image": "Välj bild"
            },
            "attributes": {
                "name": "Namn",
                "image": "Bild",
                "intro_header": "Introduktion: Rubrik",
                "intro_body": "Introduktion: Text",
                "thanks_header": "Tack: Rubrik",
                "thanks_body": "Tack: Text",
                "requires_bankid_signature": "Kräver BankID-signatur",
                "question": {
                    "prompt": "Fråga",
                    "type": "Typ",
                    "optional": "Valfri",
                    "options": "Alternativ"
                }
            }
        },
        "integrations": {
            "editor": {
                "header": "Integrationer"
            }
        },
        "upload": {
            "submitExplain": "Skicka in bild/dokument",
            "instructions": "För att skicka in en bild eller ett dokument till säljaren, använd formuläret nedan. Formuläret accepterar filer i formaten pdf, jpg och png.",
            "label": "Bild/Dokument *",
            "desc": "Beskrivning *"
        },
        "chat": {
            "moduleName": "Chatt",
            "moduleEnable": "Lägg till chatt som standard",
            "disabledOnFullySigned": "Inaktivera efter signering",
            "defaultMessageTitle": "Standardmeddelande (kan redigeras)",
            "defaultMessageOffer": "Initialt chattmeddelande vid utskick med erbjudande",
            "defaultMessageBusinessCard": "Initialt chattmeddelande vid utskick som visitkort/lead",
            "reminderUnreadTitle": "Påminnelse om oläst chatt-meddelande (sms, email)",
            "responseTimeText": "Förväntad svarstid",
            "replyAsEnable": "Aktivera väljare för \"svara som\" i chatten"
        }
    }
}
